module.exports = __webpack_public_path__ + "static/media/annotate_whiteboard_dark.5ea4ec06.svg";